var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.cancelShow
    ? _c("div", { staticClass: "popup" }, [
        _c("div", { staticClass: "content", attrs: { id: "cancelSub" } }, [
          _c("div", { staticClass: "title" }, [
            _vm.isUser
              ? _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.$t("language.popup.subAccountPopup.cancel.titleUser")
                    )
                  )
                ])
              : _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.$t("language.popup.subAccountPopup.cancel.titleItem")
                    )
                  )
                ]),
            _vm._v(" "),
            _c("div", {
              staticClass: "icon white-close dialog-close",
              on: {
                click: function($event) {
                  return _vm.closePage()
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "cancel-all-content" }, [
            _vm.isUser
              ? _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.$t("language.popup.subAccountPopup.cancel.msgUser")
                    )
                  )
                ])
              : _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.$t("language.popup.subAccountPopup.cancel.msgItem")
                    )
                  )
                ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "cancel-all-footer" }, [
            _c("div", { staticClass: "cancel-all-footer-left" }, [
              !_vm.loading
                ? _c(
                    "button",
                    {
                      on: {
                        click: function($event) {
                          return _vm.cancelSub()
                        }
                      }
                    },
                    [_c("span", [_vm._v(_vm._s(_vm.$t("language.common.ok")))])]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.loading
                ? _c("button", {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.loading,
                        expression: "loading"
                      }
                    ]
                  })
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "cancel-all-footer-right" }, [
              _c(
                "button",
                {
                  on: {
                    click: function($event) {
                      _vm.cancelShow = false
                    }
                  }
                },
                [_c("span", [_vm._v(_vm._s(_vm.$t("language.common.cancel")))])]
              )
            ])
          ])
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3ac8a11b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ac8a11b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/popup/sub_account_popups/cancel_popup.vue
// module id = null
// module chunks = 